import { Card, Heading } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

type StepsCardProps = {
  title: string;
  description: string;
} & PropsWithChildren;
export const StepsCard = ({ children, title, description }: StepsCardProps) => {
  return (
    <Card.Root borderRadius="3xl" w={620}>
      <Card.Header textAlign="center">
        <Heading size="2xl" fontWeight="700">
          {title}
        </Heading>
        <Heading color="fg.muted" fontSize="lg" fontWeight="500">
          {description}
        </Heading>
      </Card.Header>
      <Card.Body spaceY={4}>{children}</Card.Body>
      <Card.Footer></Card.Footer>
    </Card.Root>
  );
};
